<template>
	<div id="content" class="content join join_done">
		<div class="container">

			<div class="page-title">
				<h2 class="tit">KAKAO 로그인 진행중</h2>
				<p class="sub-tit">KAKAO 인증이 진행중입니다. 잠시만 기다려 주세요.</p>
				<input class="inp-id" type="text" id="deviceToken" v-show="LOCAL === 'localhost'" placeholder="장치 토큰" readonly="readonly">
			</div>

		</div>
	</div>
</template>

<script>
export default {
	name: "kakaoReturn",
	data() {
		return{
			LOCAL: location.hostname,
		}
	},
	mounted() {
		this.appDeviceToken("#deviceToken")
	},
}
</script>

<style scoped>

</style>
